module.exports = __webpack_public_path__ + "static/media/3.3bd79e95.jpg";